import { useState } from 'react'
import { Modal, Button, Field } from '../ds/index.js'

export default function NewProjectModal({ onClose, onCreate }) {
  const [name, setName] = useState('')
  const [subtitle, setSubtitle] = useState('')
  const valid = name.trim().length > 0

  const submit = () => {
    if (valid) onCreate({ name: name.trim(), subtitle: subtitle.trim() || 'New project' })
  }
  const onKey = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      submit()
    }
  }

  return (
    <Modal
      onClose={onClose}
      title="New Project"
      size="sm"
      footer={
        <>
          <Button variant="ghost" onClick={onClose}>Cancel</Button>
          <Button onClick={submit} disabled={!valid}>Create Project</Button>
        </>
      }
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
        <Field
          label="Project name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          onKeyDown={onKey}
          autoFocus
          placeholder="e.g. Brand Refresh"
        />
        <Field
          label="Description"
          value={subtitle}
          onChange={(e) => setSubtitle(e.target.value)}
          onKeyDown={onKey}
          placeholder="Short summary (optional)"
        />
      </div>
    </Modal>
  )
}
